import styled from "styled-components";
import { List, Button, Type } from "discover.medical.react-component-library";

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.anchor};
  text-decoration: none;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`;

export const StyledFooter = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.colors.gray800};
`;

export const StyledContent = styled.div`
  margin-bottom: ${({ theme }) => theme.space.md};
  line-height: 1.375rem;
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.colors.gray800};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    line-height: ${({ theme }) => theme.line.height.base};
    font-size: ${({ theme }) => theme.font.size.md};
  }
`;

export const StyledWrap = styled.div`
  border: 0.0625rem solid ${({ theme }) => theme.colors.gray400};
  background-color: ${({ theme }) => theme.colors.gray100};
  padding: 0.6rem 0.9rem 0.9rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.space.md} 1.2rem;
  }
`;

export const StyledHeading = styled(Type)`
  padding: 0;
  margin-bottom: 0.3rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 0.8rem;
  }
`;

export const StyledList = styled(List)`
  list-style: none;
  margin-bottom: ${({ theme }) => theme.space.sm};
  color: ${({ theme }) => theme.colors.gray800};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 0.7rem;
  }
`;

export const StyledListItem = styled(List.Item)`
  color: ${({ theme }) => theme.colors.gray800};
  font-size: ${({ theme }) => theme.font.size.sm};
  line-height: 1.75rem;
  display: flex;
  margin-bottom: 0.1rem;

  padding-top: 0.2rem;
  &:not(:first-child) {
    border-top: 1px ${({ theme }) => theme.colors.gray400} solid;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 0.4rem;
    font-size: ${({ theme }) => theme.font.size.md};
    line-height: ${({ theme }) => theme.line.height.base};
    align-items: flex-end;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: center;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    padding: 0.1rem 0.6rem;
    color: ${({ theme }) => theme.colors.anchor};
    border-color: ${({ theme }) => theme.colors.primary.base};
  }
  font-size: ${({ theme }) => theme.font.size.sm};
`;

export const StyledType = styled(Type)`
  margin-left: auto;
  padding-right: 0.2rem;
  line-height: inherit;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-left: 1.3rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 0;
  }
`;
